// extracted by mini-css-extract-plugin
export var wrapper = "SliderButton-module--wrapper--5441e";
export var arrowIcon = "SliderButton-module--arrowIcon--3e189";